import type { FloatingBoundaryValue } from "@faire/slate/private/floating/FloatingBoundaryContext";

/**
 * Maps a floating boundary value to Floating UI detectOverflow boundary options.
 * Padding is merged separately via mergeFloatingDetectOverflowPadding.
 */
export const getFloatingBoundaryDetectOverflowOptions = (
  boundary: FloatingBoundaryValue
): { boundary: Element } | Record<string, never> =>
  boundary.element ? { boundary: boundary.element } : {};
